@if (loading | async) {
    <div class="p-5 d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="d-flex flex-column">
        <div class="d-flex flex-row">
            <div *ngIf="shouldDisplayLogo" class="d-flex justify-content-center align-items-center org-photo">
                <img [src]="org.logo.photo_url" [alt]="org.name" (error)="couldNotLoadLogo()"/>
            </div>
            <app-detail-info-card class="org-info" [data]="basicInfo" [disableShadow]="true"></app-detail-info-card>
        </div>
    </div>
}